module.exports = __webpack_public_path__ + "static/media/1542318724357529829626 - Citizen Datasteward.09d54e16.jpg";